import React from 'react';
import Markup from "interweave";

const NewsItem = ({item}) => (
  <article className="article--snippet col-4 margin__bottom">
    <a href={item.url}  className="no-decoration">
      <div className="article--snippet--image aspect-ratio__16_9">
        <img src="http://www.ohb.scot.nhs.uk/sites/default/files/styles/s/public/NHSO_logo_web.jpg" />
      </div>
      <div className="article--snippet--content padding__16 background__mist">
        <h2 className="article--snippet--title blue heading heading__small">{item.title}</h2>
        <p className="article--snippet--date navy text__small">
          {`Published ${item.date}`}
        </p>
        <div className="article--snippet--summary navy">
          <Markup content={item.body} />
        </div>
      </div>
    </a>
  </article>
);

export default NewsItem;
